import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../ButtonWithLoader';
import VotesTypes from '../../../Utils/Types/VoteTypes';
import EmojiIcon from './EmojiIcon';

function CounterButton({ active = false, showLabel = true, reaction, children, ...props }: any) {
  if (!showLabel) {
    return (
      <Button variant={active ? 'contained' : 'outlined'} {...props}>
        <EmojiIcon reaction={reaction} />
      </Button>
    );
  }
  return (
    <Button
      variant={active ? 'contained' : 'outlined'}
      startIcon={<EmojiIcon reaction={reaction} />}
      loadingPosition="start"
      {...props}
    >
      {children}
    </Button>
  );
}

CounterButton.propTypes = {
  active: PropTypes.bool,
  reaction: PropTypes.oneOf(Object.values(VotesTypes)).isRequired,
};

export default CounterButton;
